import { render, staticRenderFns } from "./NewAppVersion.vue?vue&type=template&id=6b76fa8e&scoped=true"
import script from "./NewAppVersion.vue?vue&type=script&lang=js"
export * from "./NewAppVersion.vue?vue&type=script&lang=js"
import style0 from "./NewAppVersion.vue?vue&type=style&index=0&id=6b76fa8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76fa8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b76fa8e')) {
      api.createRecord('6b76fa8e', component.options)
    } else {
      api.reload('6b76fa8e', component.options)
    }
    module.hot.accept("./NewAppVersion.vue?vue&type=template&id=6b76fa8e&scoped=true", function () {
      api.rerender('6b76fa8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewAppVersion.vue"
export default component.exports